module.exports = "/images/vendor/flag-icon-css/flags/4x3/mu.svg?896330b72092b57179e09d43f831211b";